module.exports = __webpack_public_path__ + "static/media/strategy-tasks-work.5bb4c042.svg";